<template>
  <b-modal
    :visible="value"
    :title="modalTitle"
    size="md"
    hide-footer
    centered
    @change="modalChangeEvent"
  >
    <BfInput
      v-model="filename"
      data-key="titulo"
      :label="nameFieldLabel"
      :placeholder="nameFieldPlaceholder"
      :errors="formErrors"
      :left-border="false"
    />

    <div v-if="formattedErrors" class="mt-2">
      <p class="text-danger" v-html="formattedErrors" />
    </div>

    <div class="mt-4 text-right">
      <BfButton variant="secondary" class="mr-3" @click="modalChangeEvent(false)">Cancelar</BfButton>
      <BfButton @click="saveFormData" :disabled="disableSaveButton">{{saveButtonLabel}}</BfButton>
    </div>
  </b-modal>
</template>

<script>
import get from 'lodash.get';
import { documentAPI } from '@/api';

export default {
  name: 'documentacionChangeNameModal',

  props: {
    initialFormData: {
      type: Array,
      default: () => [],
    },

    formErrors: {
      type: Object,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      formData: this.initialFormData,
      filename: '',
    };
  },

  methods: {
    modalChangeEvent(visible) {
      this.formData = !visible ? {} : this.initialFormData;
      this.$emit('input', visible);
    },

    async saveFormData() {
      try {
        const { data, message } = await documentAPI.renameDocument({
          documentsId: this.formData,
          newTitle: this.filename,
        });
        this.$emit('input', false);
        this.$emit('updateDocuments');
        this.$bfNotify({
          type: 'success',
          title: 'Edición correcta',
          message,
        });
        this.filename = '';
      } catch ({ message }) {
        this.$bfNotify({
          type: 'error',
          title: 'Error',
          message,
        });
      }

      // this.$emit("save-data", this.formData);
    },
  },

  computed: {
    plural() {
      if (this.formData.length > 1) {
        return true;
      }
    },

    disableSaveButton() {
      if (this.filename.length < 1) {
        return true;
      }
    },

    formattedErrors() {
      if (
        !this.formErrors ||
        (this.formErrors && !Object.keys(this.formErrors).length)
      ) {
        return null;
      }

      return Object.keys(this.formErrors)
        .filter(key => ['titulo', 'categoria'].indexOf(key) === -1)
        .map((key) => {
          const errors = this.formErrors[key] || [];

          return errors.join('<br />');
        })
        .join('<br />');
    },

    modalTitle() {
      return `Editar documento${this.plural ? 's' : ''}`;
    },

    saveButtonLabel() {
      return `Editar nombre${this.plural ? 's' : ''}`;
    },

    nameFieldLabel() {
      return `Introduce el nuevo título para ${
        this.plural ? 'los documentos' : 'el documento'
      }`;
    },

    nameFieldPlaceholder() {
      return !this.plural
        ? 'Escribe el nombre del fichero'
        : 'Escribe el nombre para los ficheros';
    },
  },

  watch: {
    initialFormData(newData) {
      this.formData = newData;
    },
  },
};
</script>

<style lang="scss" scoped>
.category-checkbox /deep/ .bf-label-wrap {
  display: none;
}
</style>
